/* eslint-disable no-useless-escape */
/* eslint-disable no-irregular-whitespace */
import moment from 'moment'
import numeral from 'numeral'
import { PAGE } from '@/constants/page.js'
import { toCapitalCase } from '@/utils/transformCase'

const xss_crosssite_script_regex =
  /<[^\w<>]*(?:[^<>"'\s]*:)?[^\w<>]*(?:\W*s\W*c\W*r\W*i\W*p\W*t|\W*f\W*o\W*r\W*m|\W*s\W*t\W*y\W*l\W*e|\W*s\W*v\W*g|\W*m\W*a\W*r\W*q\W*u\W*e\W*e|(?:\W*l\W*i\W*n\W*k|\W*o\W*b\W*j\W*e\W*c\W*t|\W*e\W*m\W*b\W*e\W*d|\W*a\W*p\W*p\W*l\W*e\W*t|\W*p\W*a\W*r\W*a\W*m|\W*i?\W*f\W*r\W*a\W*m\W*e|\W*b\W*a\W*s\W*e|\W*b\W*o\W*d\W*y|\W*m\W*e\W*t\W*a|\W*i\W*m\W*a?\W*g\W*e?|\W*v\W*i\W*d\W*e\W*o|\W*a\W*u\W*d\W*i\W*o|\W*b\W*i\W*n\W*d\W*i\W*n\W*g\W*s|\W*s\W*e\W*t|\W*i\W*s\W*i\W*n\W*d\W*e\W*x|\W*a\W*n\W*i\W*m\W*a\W*t\W*e)[^>\w])|(?:<\w[\s\S]*[\s\0\/]|['"])(?:formaction|style|background|src|lowsrc|ping|on(?:d(?:e(?:vice(?:(?:orienta|mo)tion|proximity|found|light)|livery(?:success|error)|activate)|r(?:ag(?:e(?:n(?:ter|d)|xit)|(?:gestur|leav)e|start|drop|over)?|op)|i(?:s(?:c(?:hargingtimechange|onnect(?:ing|ed))|abled)|aling)|ata(?:setc(?:omplete|hanged)|(?:availabl|chang)e|error)|urationchange|ownloading|blclick)|Moz(?:M(?:agnifyGesture(?:Update|Start)?|ouse(?:PixelScroll|Hittest))|S(?:wipeGesture(?:Update|Start|End)?|crolledAreaChanged)|(?:(?:Press)?TapGestur|BeforeResiz)e|EdgeUI(?:C(?:omplet|ancel)|Start)ed|RotateGesture(?:Update|Start)?|A(?:udioAvailable|fterPaint))|c(?:o(?:m(?:p(?:osition(?:update|start|end)|lete)|mand(?:update)?)|n(?:t(?:rolselect|extmenu)|nect(?:ing|ed))|py)|a(?:(?:llschang|ch)ed|nplay(?:through)?|rdstatechange)|h(?:(?:arging(?:time)?ch)?ange|ecking)|(?:fstate|ell)change|u(?:echange|t)|l(?:ick|ose))|m(?:o(?:z(?:pointerlock(?:change|error)|(?:orientation|time)change|fullscreen(?:change|error)|network(?:down|up)load)|use(?:(?:lea|mo)ve|o(?:ver|ut)|enter|wheel|down|up)|ve(?:start|end)?)|essage|ark)|s(?:t(?:a(?:t(?:uschanged|echange)|lled|rt)|k(?:sessione|comma)nd|op)|e(?:ek(?:complete|ing|ed)|(?:lec(?:tstar)?)?t|n(?:ding|t))|u(?:ccess|spend|bmit)|peech(?:start|end)|ound(?:start|end)|croll|how)|b(?:e(?:for(?:e(?:(?:scriptexecu|activa)te|u(?:nload|pdate)|p(?:aste|rint)|c(?:opy|ut)|editfocus)|deactivate)|gin(?:Event)?)|oun(?:dary|ce)|l(?:ocked|ur)|roadcast|usy)|a(?:n(?:imation(?:iteration|start|end)|tennastatechange)|fter(?:(?:scriptexecu|upda)te|print)|udio(?:process|start|end)|d(?:apteradded|dtrack)|ctivate|lerting|bort)|DOM(?:Node(?:Inserted(?:IntoDocument)?|Removed(?:FromDocument)?)|(?:CharacterData|Subtree)Modified|A(?:ttrModified|ctivate)|Focus(?:Out|In)|MouseScroll)|r(?:e(?:s(?:u(?:m(?:ing|e)|lt)|ize|et)|adystatechange|pea(?:tEven)?t|movetrack|trieving|ceived)|ow(?:s(?:inserted|delete)|e(?:nter|xit))|atechange)|p(?:op(?:up(?:hid(?:den|ing)|show(?:ing|n))|state)|a(?:ge(?:hide|show)|(?:st|us)e|int)|ro(?:pertychange|gress)|lay(?:ing)?)|t(?:ouch(?:(?:lea|mo)ve|en(?:ter|d)|cancel|start)|ime(?:update|out)|ransitionend|ext)|u(?:s(?:erproximity|sdreceived)|p(?:gradeneeded|dateready)|n(?:derflow|load))|f(?:o(?:rm(?:change|input)|cus(?:out|in)?)|i(?:lterchange|nish)|ailed)|l(?:o(?:ad(?:e(?:d(?:meta)?data|nd)|start)?|secapture)|evelchange|y)|g(?:amepad(?:(?:dis)?connected|button(?:down|up)|axismove)|et)|e(?:n(?:d(?:Event|ed)?|abled|ter)|rror(?:update)?|mptied|xit)|i(?:cc(?:cardlockerror|infochange)|n(?:coming|valid|put))|o(?:(?:(?:ff|n)lin|bsolet)e|verflow(?:changed)?|pen)|SVG(?:(?:Unl|L)oad|Resize|Scroll|Abort|Error|Zoom)|h(?:e(?:adphoneschange|l[dp])|ashchange|olding)|v(?:o(?:lum|ic)e|ersion)change|w(?:a(?:it|rn)ing|heel)|key(?:press|down|up)|(?:AppComman|Loa)d|no(?:update|match)|Request|zoom))[\s\0]*=/gi

export default {
  methods: {
    escapeCsvValue(value) {
      // Always convert to string; treat null/undefined as empty string
      let strValue = value == null ? '' : String(value)

      // Normalize: remove a leading BOM if present (common when concatenating files)
      if (strValue.charCodeAt(0) === 0xfeff) {
        strValue = strValue.slice(1)
      }

      // Unicode “invisible/whitespace” that attackers can prepend before = + - @
      // Includes: ASCII control/space, NBSP, EN/EM spaces, thin spaces,
      // zero-width (ZWSP/ZWNJ/ZWJ/WORD JOINER), line/para sep, etc.
      const LEADING_INVISIBLES =
        /^[\u0000-\u0020\u00A0\u1680\u2000-\u200A\u200B\u200C\u200D\u2028\u2029\u202F\u205F\u2060\u3000\uFEFF]*/u

      // If after stripping leading invisibles the next char is =, +, -, or @,
      // prefix an apostrophe to force Excel to treat it as text.
      const leading = (strValue.match(LEADING_INVISIBLES) || [''])[0]
      const nextChar = strValue.slice(leading.length, leading.length + 1)

      if ('=+-@'.includes(nextChar) && !strValue.startsWith("'")) {
        strValue = "'" + strValue
      }

      // Escape double quotes per RFC 4180
      strValue = strValue.replace(/"/g, '""')

      // Wrap if special chars present (quote, comma, newline, carriage return)
      if (/[",\n\r]/.test(strValue)) {
        strValue = `"${strValue}"`
      }

      return strValue
    },
    parseConversation(intent, options) {
      const vm = this
      const { isCommentToInbox, isLiveStream } = options
      if (isCommentToInbox || isLiveStream) {
        if (vm.isJsonParseable(intent.a_val)) {
          return JSON.parse(intent.a_val)
        } else {
          return [
            [
              {
                type: 'text',
                text: intent.a_val
              }
            ]
          ]
        }
      } else if (intent.a_val == '{welcome_message}') {
        return [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (intent.a_type == 'json') {
        return JSON.parse(intent.a_val)
      } else if (intent.a_val != '' && intent.a_type == 'text') {
        const group_messages = intent.a_val.split('||')
        const newGroup = group_messages.map((group) => {
          const messages = group.split('#nl')
          const newMessages = messages.map((message) => {
            if (vm.isURL(message)) {
              return {
                type: 'image',
                value: message
              }
            } else if (!isNaN(message)) {
              return {
                type: 'text',
                value: {
                  text: message,
                  buttons: []
                }
              }
            } else if (vm.isJsonParseable(message)) {
              return {
                type: 'text',
                value: JSON.parse(message)
              }
            } else {
              return {
                type: 'text',
                value: {
                  text: message,
                  buttons: []
                }
              }
            }
          })

          return newMessages
        })

        return newGroup
      } else if (intent.a_type == 'template') {
        if (vm.isJsonParseable(intent.a_val)) {
          return JSON.parse(intent.a_val)
        } else {
          return []
        }
      } else if (intent.a_type == 'message') {
        return [
          [
            {
              type: 'text',
              text: intent.a_val
            }
          ]
        ]
      } else if (intent.a_type == 'none') {
        return [[]]
      } else if (intent.a_type == 'viewsummary') {
        return [
          [
            {
              type: 'text',
              text: '{viewsummary}'
            }
          ]
        ]
      }
    },
    keyIsNumber: function (evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },
    DateFormat(val, format = 'DD/MM/YYYY') {
      if (!val) return ''
      return moment(val).format(format)
    },
    noSpaceAndSpecial(event, noTrim) {
      var val

      if (typeof event == 'string') {
        val = event
      } else if (event && event.target) {
        val = event.target.value
      } else {
        return true
      }

      try {
        if (!noTrim) {
          val = val.trim()
        }
        return val
          .replace(/[!$^,?|]/g, '')
          .replace(xss_crosssite_script_regex, '')
          .replace(/(‘|’)/gim, '')
          .replace(/(“|”)/gim, '')
          .replace(/​/gim, '')
          .replace(/ /gim, '')
      } catch (error) {
        return ''
      }
    },
    numberOnly(event, type) {
      const val = event.target.value.trim()
      let result
      console.log(val, 'val')
      if (!val) return val
      if (typeof val === 'string') {
        // remove all non digit
        result = val.replace(/\D/g, '')
      }
      result = +result
      console.log(result, 'result')
      if (type == 'hour') {
        if (result >= 24) {
          result = 23
        }
      } else if (type == 'minute') {
        if (result >= 60) {
          result = 59
        }
      }

      return result
    },
    decimalOnly(event) {
      var val = event.target.value.trim()
      return numeral(val).value()
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    isSupportLanguage: function (message, ispremium) {
      if (ispremium) return true
      else {
        return (
          message.search(
            /[^ก-๛a-zA-Z0-9\~\$\&\+\,\:\;\=\?\@\#\|\'\"\<\>\.\^\*\(\)\%\!\-\/\[\]\\\_\{\}\s]/gim
          ) === -1
        )
      }
    },
    isURL: function (str) {
      var pattern = new RegExp(
        /^(ftp|http|https|line):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/
      ) // fragment locator
      return pattern.test(str)
    },
    isImageURL: function (str) {
      var pattern = new RegExp(/(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png)/g) // fragment locator
      return pattern.test(str)
    },
    isJsonParseable: function (str) {
      try {
        JSON.parse(str)
      } catch (e) {
        return false
      }
      return true
    },
    isNumber: function (str) {
      try {
        parseFloat(str)
      } catch (e) {
        return false
      }
      return true
    },
    exportCsv: function (csvContent, name) {
      var csvData = new Blob(['\uFEFF' + csvContent], { type: 'text/csv; charset=utf-18' }) // new way
      var csvUrl = URL.createObjectURL(csvData)

      var link = document.createElement('a')
      link.setAttribute(
        'style',
        'overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;'
      )
      link.setAttribute('href', csvUrl)
      link.setAttribute('download', moment().format('YYYY_MM_DD') + '_' + name + '.csv')
      link.innerHTML = 'Click Here to download'
      document.body.appendChild(link) // Required for FF

      link.click()
    },
    exportText: function (csvContent, name) {
      var csvData = new Blob(['\uFEFF' + csvContent], { type: 'text/plain; charset=utf-18' }) // new way
      var csvUrl = URL.createObjectURL(csvData)

      var link = document.createElement('a')
      link.setAttribute(
        'style',
        'overflow: hidden;position: fixed;width: 1px;height: 1px;z-index: -1;opacity: 0;'
      )
      link.setAttribute('href', csvUrl)
      link.setAttribute('download', name + '.txt')
      link.innerHTML = 'Click Here to download'
      document.body.appendChild(link) // Required for FF

      link.click()
    },
    setLang: function (lang) {
      this.$store.dispatch('setLang', lang)
    },
    checkEmptyReplyMessage(messages) {
      return messages
        .map(function (m) {
          if (
            (m[0].replyinbox === true &&
              m[0].responseinbox[0].text !== '' &&
              m[0].responseinbox[0].text !== null) ||
            (m[0].replycomment === true &&
              m[0].responsecomment[0].text !== '' &&
              m[0].responsecomment[0].text !== null) ||
            m[0].hidecomment === true
          ) {
            if (m[0].replyinbox === true && m[0].responseinbox[0].type === 'generic') {
              m[0].responseinbox[0].data = m[0].responseinbox[0].data.filter((v) => {
                return v.image_url || v.title || v.subtitle
              })
            }
            return m
          } else {
            return null
          }
        })
        .filter((el) => {
          return el != null
        })
    },
    numberFormat(val) {
      return new Intl.NumberFormat().format(parseFloat(val))
    },
    kFormatter(num) {
      return Math.abs(num) > 999
        ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + 'k'
        : Math.sign(num) * Math.abs(num)
    },
    checkEmptyMessage(messages) {
      let result = []
      for (let index = 0; index < messages.length; index++) {
        const message = messages[index]
        let formatMessages = []
        for (let mindex = 0; mindex < message.length; mindex++) {
          const msg = message[mindex]
          if (msg.type === 'text') {
            if (msg.text !== '' && msg.text != null) {
              formatMessages.push(msg)
            }
          } else if (msg.type === 'button') {
            if ((msg.text !== '' && msg.text != null) || msg.buttons.length > 0) {
              formatMessages.push(msg)
            }
          } else if (msg.type === 'image') {
            if (msg.image_url) {
              formatMessages.push(msg)
            }
          } else if (msg.type === 'generic') {
            let generics = msg.data.filter((generic) => {
              return (
                generic.image_url != null ||
                generic.title !== '' ||
                generic.subtitle !== '' ||
                (typeof generic.productid != 'undefined' && generic.productid != null) ||
                generic.buttons.length > 0
              )
            })

            if (generics.length > 0) {
              formatMessages.push({
                type: 'generic',
                data: generics,
                ratio: msg.ratio == 'horizontal' ? 'horizontal' : 'square'
              })
            }
          } else if (msg.type === 'flex') {
            if (msg.contents !== '' && msg.contents != null) {
              formatMessages.push(msg)
            }
          } else if (msg.type) {
            formatMessages.push(msg)
          }
        }
        if (formatMessages.length > 0) result.push(formatMessages)
      }

      if (result.length === 0) {
        result = [[]]
      }

      return result
    },
    formatAnswer(a_val, a_type) {
      var vm = this
      if (vm.isCommentToInbox || vm.isLiveStream) {
        if (vm.isJsonParseable(a_val)) {
          return JSON.parse(a_val)
        } else {
          return [
            [
              {
                type: 'text',
                text: a_val
              }
            ]
          ]
        }
      } else if (a_val == '{welcome_message}') {
        return [
          [
            {
              type: 'welcome_message'
            }
          ]
        ]
      } else if (a_type == 'json') {
        try {
          return JSON.parse(a_val)
        } catch (error) {
          // console.log(a_val)
        }
      } else if (a_val != '' && a_type == 'text') {
        const group_messages = a_val.split('||')
        const newGroup = group_messages.map((group) => {
          const messages = group.split('#nl')
          const newMessages = messages.map((message) => {
            if (vm.isURL(message)) {
              return {
                type: 'image',
                value: message
              }
            } else if (!isNaN(message)) {
              return {
                type: 'text',
                value: {
                  text: message,
                  buttons: []
                }
              }
            } else if (vm.isJsonParseable(message)) {
              return {
                type: 'text',
                value: JSON.parse(message)
              }
            } else {
              return {
                type: 'text',
                value: {
                  text: message,
                  buttons: []
                }
              }
            }
          })
          return newMessages
        }, [])

        return newGroup
      } else if (a_type == 'template') {
        if (vm.isJsonParseable(a_val)) {
          return JSON.parse(a_val)
        } else {
          return []
        }
      } else if (a_type == 'message') {
        return [
          [
            {
              type: 'text',
              text: a_val
            }
          ]
        ]
      } else if (a_type == 'none') {
        return [[]]
      } else if (a_type == 'viewsummary') {
        return [
          [
            {
              type: 'text',
              text: '{viewsummary}'
            }
          ]
        ]
      }
    },
    intentTemplate() {
      return {
        intentname: '',
        q_type: 'text',
        a_type: 'json',
        q_val: '',
        a_val: '',
        fb_val: '',
        line_val: '',
        ig_val: '',
        fb_quick_reply: '',
        line_quick_reply: '',
        ig_quick_reply: '',
        context_in: '',
        context_out: '',
        postidlist: '',
        isShow: false,
        userstatus: null,
        usertags: null,
        linenoti_status: false,
        linenoti_spec_ids: null,
        linenoti_text: null,
        starttime: null,
        endtime: null,
        intentstatus: true,
        follow_up_fb_quick_reply: null,
        follow_up_fb_val: null,
        follow_up_ig_quick_reply: null,
        follow_up_ig_val: null,
        follow_up_line_quick_reply: null,
        follow_up_line_val: null,
        follow_up_quick_reply: null,
        follow_up_status: null,
        follow_up_type: null,
        follow_up_val: null,
        follow_up_within_seconds: null,
        not_reply_within_seconds: null,
        not_reply_within_times: null,
        frequency_per_day: null,
        exceptpostidlist: '',
        post_keywords: '',
        onlytime: false,
        quick_reply: '',
        follow_up_usertags: '',
        intentgroup: null
      }
    },
    isZwizAdmin() {
      if (!this.$store.state.userid) return false
      const string = '^zwiz'
      const regexp = new RegExp(string)

      return regexp.test(this.$store.state.userid) // true
    },
    checkType(obj, type) {
      return typeof obj === type
    },
    intentLabel(label) {
      if (label == '{default}') return this.$t('Default Conversation')
      else if (label == null) return this.$t('Other')
      else if (label == '{welcome}') return this.$t('Welcome Message')
      else if (label == '{maintenance_message}') return 'บอทตอบเวลาปรับปรุงระบบ'
      else if (label == '{default_comment_to_inbox}') return this.$t('More Comment to Inbox')
      else return label
    },
    slice(data, start = 0, end) {
      return data.filter((item, index) => {
        return index >= start && index < end + start
      })
    },
    getPackageConfig() {
      return {
        price: 0,
        reply_comment: 999,
        inbox: 999,
        products: 3000,
        bubbles: 10,
        imageMap: false,
        coupon: true,
        couponQuantity: 10,
        salePage: false,
        wholeSale: true,
        salesReport: true,
        cartSummary: true,
        salepageAnalytics: true,
        chatGpt: true,
        verifySlip: 10,
        adsSimulator: 300
      }
    },
    intentBeaconTemplate() {
      return {
        campaign_name: '',
        q_type: 'text',
        a_type: 'json',
        q_val: 'exacts(beacon_enter)',
        a_val: [[]],
        context_in: '',
        context_out: '',
        pageidlist: '',
        userstatus: '',
        usertags: '',
        linenoti_status: false,
        linenoti_text: null,
        linenoti_spec_ids: null,
        starttime: null,
        endtime: null,
        status: true
      }
    },
    formatTime(time, props) {
      props = props || {}
      props.defaultHour = props.defaultHour || '00'
      props.defaultMinius = props.defaultMinius || '00'
      if (time) {
        return (time['HH'] || props.defaultHour) + ':' + (time['mm'] || props.defaultMinius)
      }
      return `${props.defaultHour}:${props.defaultMinius}`
    },
    handleGetAvailableChannel() {
      let channels = ['fb']
      const selectedBot = this.$store.getters.selectedBot
      if (selectedBot) {
        if (selectedBot.line_modular_botid || selectedBot.line_access_token) {
          channels.push('line')
        }
        const com7page = this.$store.state.com7pages.map((page) => page.pageid)
        if (
          selectedBot.instagram_status == true &&
          selectedBot.instagram_business_account &&
          (!com7page.includes(selectedBot.pageid) || selectedBot.unlock_instagram)
        ) {
          channels.push('ig')
        }
        if (this.$store.state.powerbuyTest.includes(selectedBot.pageid)) {
          channels.push('ig')
        }
        switch (selectedBot.type) {
          case 'gpf':
            channels.push('webchat', 'app')
            break
          case 'trueid':
          case 'mtc':
          case 'sprc':
            channels.push('ms_team', 'webchat')
            break
          case 'dtac-gaming':
            channels = ['fb']
            break
          case 'demo':
            channels = ['webchat']
            break
          default:
            break
        }
        if (PAGE.DDPROPERTY.includes(selectedBot.pageid) || selectedBot.unlock_webchat) {
          channels.push('webchat')
        }
        if (selectedBot.whatsapp_status && selectedBot.unlock_whatsapp) {
          channels.push('whatsapp')
        }
      }
      return channels
    },
    toCapitalCase(str) {
      return toCapitalCase(str)
    }
  },
  computed: {
    socialChannelOptions() {
      const channels = this.handleGetAvailableChannel()
      const channelOptions = this.$store.state.socialChannelOptions.filter((el) =>
        channels.includes(el.value)
      )
      return channelOptions
    },
    conversationSocialChannelOptions() {
      // const selectedBot = this.$store.getters.selectedBot
      const channels = this.handleGetAvailableChannel()
      const channelOptions = this.$store.state.socialChannelOptions.filter((el) => {
        return channels.includes(el.value)
      })
      return channelOptions
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/mainMixin.js